import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AppBar, Toolbar, Typography, Box, IconButton, Avatar, Menu, MenuItem, Divider } from '@mui/material';
import { Notifications, Group, Description, Gavel, Logout, ArrowDropDown } from '@mui/icons-material';
import { API_URL } from '../apiConfig';


const TopBar = ({ handleLogout }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [userDetails, setUserDetails] = useState({ first_name: '', last_name: '', email: '' });

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const { data } = await axios.get(`${API_URL}/api/user_details`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const fullName = data.type === 'team_member' ? data.name.split(' ') : data.contact_person.split(' ');
        setUserDetails({
          first_name: fullName[0],
          last_name: fullName.length > 1 ? fullName[fullName.length - 1] : '',
          email: data.email
        });
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    };
    fetchUserDetails();
  }, []);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const initials = `${userDetails.first_name.charAt(0)}${userDetails.last_name.charAt(0)}`;

  const openPopup = (url) => {
    window.open(url, 'popup', 'width=600,height=600');
    handleMenuClose();
  };

  const menuItems = [
    { icon: <Description />, text: 'Terms of Service', onClick: () => openPopup('/terms_and_conditions.html') },
    { icon: <Gavel />, text: 'Privacy Policy', onClick: () => openPopup('/privacy.html') },
  ];

  return (
    <AppBar position="fixed" sx={{ width: 'calc(100% - 240px)', ml: '240px' }}>
      <Toolbar>
        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }} />
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton color="inherit">
            <Notifications />
          </IconButton>
          <IconButton onClick={handleMenuOpen} sx={{ ml: 2 }} color="inherit">
            <Avatar>{initials}</Avatar>
            <ArrowDropDown />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            sx={{ mt: '10px' }}
          >
            <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center' }}>
              <Avatar sx={{ mr: 2 }}>{initials}</Avatar>
              <Box>
                <Typography variant="body1">{userDetails.first_name}</Typography>
                <Typography variant="body2" color="text.secondary">{userDetails.email}</Typography>
              </Box>
            </Box>
            <Divider />
            {menuItems.map((item) => (
              <MenuItem key={item.text} onClick={item.onClick}>
                {item.icon}
                <Typography variant="inherit" noWrap sx={{ ml: 1 }}>{item.text}</Typography>
              </MenuItem>
            ))}
            <Divider />
            <MenuItem onClick={() => { handleMenuClose(); handleLogout(); }}>
              <Logout />
              <Typography variant="inherit" noWrap sx={{ ml: 1 }}>Log out</Typography>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;